export default __webpack_public_path__ + "18955edeef09ea6d13ca8853a80da686.svg";